import { motion } from "framer-motion";
import Image from "next/image";
import React, { memo } from "react";

import NewCarousel, {
  CardVariants,
} from "@/components/brandRefresh/new-carousel";

const BalanceCarousel = memo(
  ({ deviceType, streams, activeIndex, setActiveIndex }) => {
    return (
      <NewCarousel
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        streams={streams}
        autoPlaySpeed={10 * 1000}
        disableTimer={deviceType === "mobile"}
        deviceType={deviceType}
      >
        <div className="flex justify-center md:w-[884px] md:h-[450px] sm:w-[600px] w-auto h-[350px] pt-6 md:pt-8 py-10">
          {streams.map((card, index) => {
            const isActive = activeIndex === index;
            const isNext =
              activeIndex === index - 1 ||
              (index === 0 && activeIndex === streams.length - 1);
            const isPrev =
              activeIndex === index + 1 ||
              (index === streams.length - 1 && activeIndex === 0);
            return (
              <motion.div
                key={card.id}
                className={`carousel-card md:w-[448px] 4xl:w-[604px] 4xl:h-[500px] sm:w-[320px] w-[286px] md:h-[354px] h-[229px] rounded-[20px] bg-onmoPurple-200 relative ${
                  isPrev ? "relative" : isNext ? "relative" : "absolute"
                }`}
                variants={CardVariants(deviceType)}
                initial="hidden"
                animate={
                  isActive
                    ? "active"
                    : isPrev
                    ? "prev"
                    : isNext
                    ? "next"
                    : "prev"
                }
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 50,
                }}
                style={{
                  position: "absolute",

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (isNext) {
                    let nextIndex = activeIndex + 1;
                    if (activeIndex === streams.length - 1) {
                      nextIndex = 0;
                    }
                    setActiveIndex(nextIndex);
                  } else if (isPrev) {
                    let prevIndex = activeIndex - 1;
                    if (activeIndex <= 0) {
                      prevIndex = streams.length - 1;
                    }
                    setActiveIndex(prevIndex);
                  }
                }}
              >
                <div
                  className={`md:w-[416px] 4xl:w-[540px] 4xl:h-[485px] sm:w-[300px] w-[266px] md:h-[335px] rounded-[20px] bg-onmoPurple-200 relative  flex m-auto justify-center items-center ${
                    isActive ? "" : "hidden"
                  }`}
                >
                  <Image
                    src={card.src}
                    width="0"
                    height="0"
                    sizes="100vw"
                    alt={card.alt}
                    style={{ width: "100%", height: "auto" }}
                    priority
                  />
                </div>
              </motion.div>
            );
          })}
        </div>
      </NewCarousel>
    );
  },
);

BalanceCarousel.displayName = "BalanceCarousel";

export default BalanceCarousel;
